import {ColorRestDto, TextColorSolidRestDto} from "@/api/pharma-cms-content-page/models";
import {ColorRestDtoModel} from "@/models/api/ColorRestDtoModel";
import {TextColorEnum} from "@/api/enums/text-color-enum";

export class TextColorSolidRestDtoModel implements TextColorSolidRestDto {
    text_color_code?: TextColorEnum | null;
    rgba?: ColorRestDto | null;

    static createWithDefaults(): TextColorSolidRestDtoModel {
        const model: TextColorSolidRestDtoModel = new this();
        model.text_color_code = null;
        model.rgba = null;
        return model;
    }

    static cloneFrom(source: TextColorSolidRestDto): TextColorSolidRestDtoModel {
        const clone: TextColorSolidRestDtoModel = new this();
        clone.text_color_code = source.text_color_code;
        if (source.rgba) {
            clone.rgba = ColorRestDtoModel.cloneFrom(source.rgba);
        }
        return clone;
    }
}
